export { SearchResults } from './SearchResults';
export type {
  SearchResultsProps,
  SearchResultsSections,
} from './SearchResults.types';
